<div id="inquiries-by-owner-box" class="input-holder">
    <div id="inquiries-by-owner" class="dashboardChart"></div>
    <fading-dialog [chartId]= "'inquiryByOwnerDialog'" #inquiryByOwnerDialog></fading-dialog>
</div>
